import PropTypes from 'prop-types';
import makeStyles from '@mui/styles/makeStyles';
import cn from 'classnames';
import { Typography } from '@mui/material';
import Styles from './styles';

const useStyles = makeStyles(Styles);

function DataLine({ label, body, classes }) {
  const styles = useStyles();
  const fieldClasses = cn(styles.dataLine, classes);

  return (
    <div className={fieldClasses}>
      {label && (
        <Typography data-testid="dataline-title" className={styles.title} variant="h6" component="span">
          {label}
        </Typography>
      )}
      <Typography data-testid="dataline-body" className={styles.info} variant="h6" component="p" noWrap>
        {body}
      </Typography>
    </div>
  );
}

DataLine.propTypes = {
  label: PropTypes.string,
  body: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  classes: PropTypes.string,
};

DataLine.defaultProps = {
  label: null,
  body: null,
  classes: '',
};

export default DataLine;
